class SessionApi {
  static login (credentials) {
    const request = new Request(`${process.env.REACT_APP_API_URL}/user/login/admin`, {
      method: 'POST',
      headers: new Headers({'Content-Type': 'application/json'}),
      body: JSON.stringify(credentials)
    })


  return fetch(request)
    .then(response => {
      if (response.status !== 200) {
        throw (response)
      }
      return response.json();
    })
    .catch(error => {
      throw(error);
    });
  }
}

export default SessionApi



// WEBPACK FOOTER //
// ./src/api/SessionApi.js